import type { ElementDefinition } from './types';
import type { TemplateProfile } from '../templates';
import { insertExhibit } from '../word/exhibit';

/** Element definition for double table exhibit insertion. */
export const doubleTableExhibitElement: ElementDefinition = {
  id: 'double-table-exhibit',
  label: 'Double Table',
  icon: 'TableCellsSplitRegular',
  description: 'Double half-width tables',
  category: 'exhibit',
  async insertAsync(profile: TemplateProfile): Promise<void> {
    await insertExhibit('double-table', profile);
  },
};

/** Toolbar action for double table exhibit insertion. */
export async function insertDoubleTableLayout(profile: TemplateProfile): Promise<void> {
  await insertExhibit('double-table', profile);
}
